import script from "./NavBody.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBody.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__